import type { InteriorSample } from "../core/interiorSamples";
import type { Locale } from "../i18n";
import { z } from "zod";

export const spaceFilters = ["commercial", "office", "condo", "townhouse"] as const;
export type SpaceFilter = typeof spaceFilters[number] | "all";

export function filterSamples(samples: readonly InteriorSample[], filter: SpaceFilter): readonly InteriorSample[] {
  return samples.filter((sample) => {
    switch (filter) {
      case "all": return true;
      case "commercial": return ["retail", "restaurant", "hospitality"].includes(sample.spaceType);
      case "office": return sample.spaceType === "office";
      case "condo": return sample.spaceType === "condo";
      case "townhouse": return sample.spaceType === "house";
    }
  });
}

export function sampleTitle(sample: InteriorSample, locale: Locale): string {
  return sample.title[locale === "ko" || locale === "th" ? locale : "en"];
}

export function selectedPublicStudio(value: unknown, studios: readonly { readonly id: string }[]): string {
  const parsed = z.uuid().safeParse(value);
  return parsed.success && studios.some(studio => studio.id === parsed.data) ? parsed.data : "";
}

export function consultationHref(locale: Locale, signedIn: boolean, studioId?: string): string {
  const parsed = z.uuid().safeParse(studioId);
  if (!parsed.success) return signedIn ? `/app?lang=${locale}` : `/login?lang=${locale}&next=/app`;
  const destination = `/app?lang=${locale}&studio=${parsed.data}`;
  return signedIn ? destination : `/login?lang=${locale}&next=${encodeURIComponent(destination)}`;
}
